import { Grid } from '@material-ui/core';
import { InputText } from 'components/InputText';
import React, { useContext, useRef, useEffect, useState } from 'react';
import Context from 'context';
import { ChartWrapper, DateWrapper } from './TimelineChart.style';
import DotLine from './DotLine';
import { Colors, Position } from 'type';

const TimelineChart = () => {
  const { setDate, setPlace, timeline, colors } = useContext(Context);
  const dateRefs = useRef<Array<HTMLDivElement | null>>([]);
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const [dotPositions, setDotPositions] = useState<Position[]>([]);

  function updatePosition() {
    if (wrapperRef.current === undefined || wrapperRef.current === null) return;

    const { top: up, left: side } = wrapperRef.current.getBoundingClientRect();

    const tmp: Position[] = dateRefs.current
      .filter((element) => element !== null && element !== undefined)
      .map((element: HTMLDivElement | null) => {
        if (element === undefined || element === null) {
          throw new Error("element shouldn't be undefined");
        }
        const { right, top, bottom } = element!.getBoundingClientRect();
        return {
          x: right - side,
          y: (top + bottom) / 2 - up,
        };
      });
    setDotPositions(tmp);
  }

  useEffect(() => {
    updatePosition();
  }, []);
  useEffect(() => {
    updatePosition();
  }, [timeline]);

  return (
    <ChartWrapper ref={wrapperRef}>
      <Grid item container spacing={4}>
        {timeline.map(({ date, activities }, dateIndex) => (
          <React.Fragment key={`${dateIndex}`}>
            <Grid item xs={3}>
              <DateWrapper ref={(el) => (dateRefs.current[dateIndex] = el)}>
                <InputText
                  fontSize='24px'
                  textAlign='right'
                  value={date}
                  color={colors[Colors.Tertiary]}
                  onChange={(e) => setDate(e.target.value, dateIndex)}
                />
              </DateWrapper>
            </Grid>
            <Grid item container xs={9} direction='column'>
              {activities.map(({ place }, activityIndex) => (
                <React.Fragment key={`${dateIndex}:${activityIndex}`}>
                  <Grid item container>
                    <Grid item xs={12}>
                      <InputText
                        fontSize='24px'
                        value={place}
                        color={colors[Colors.Tertiary]}
                        onChange={(e) =>
                          setPlace(e.target.value, dateIndex, activityIndex)
                        }
                      />
                    </Grid>
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
          </React.Fragment>
        ))}
        <DotLine dotPositions={dotPositions} />
      </Grid>
    </ChartWrapper>
  );
};

export default TimelineChart;
